import { createFileRoute } from "@tanstack/react-router";
import AdminSurveyPage from "@/pages/admin/surveys/detail";
import { useSurveysPermissions } from "@/pages/admin/surveys";

export const Route = createFileRoute("/app/admin/surveys/$surveyId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { surveyId } = Route.useParams();
  const { userCanEditAllSurveys, userCanViewAllSurveys } = useSurveysPermissions();

  return (
    <AdminSurveyPage
      surveyId={surveyId}
      userCanEditAllSurveys={userCanEditAllSurveys}
      userCanViewAllSurveys={userCanViewAllSurveys}
    />
  );
}
